import Axios from 'axios';
import config from '../config/config';

export const UseLoginPrestador = async (email, password) => {

    try {
        const res = await Axios.post(
            `${config.REACT_APP_SERVER}/api/login/worker`,
            {
                email,
                password
            }
        );

        return res.data;
    } catch (error) {
        console.log(error);
    }
}
export const UseLoginUsuario = async (email, password) => {

    try {
        const res = await Axios.post(
            `${config.REACT_APP_SERVER}/api/login/user`,
            {
                email,
                password
            }
        );

        return res.data;
    } catch (error) {
        console.log(error);
    }
}
/* TODO: Diferenciar el login con google de prestadores y usuarios. */
export const UseLoginWithGoogle = async (email) => {

    try {
        const res = await Axios.post(
            `${config.REACT_APP_SERVER}/api/login/google`,
            {
                email
            }
        );
        return res.data;
    } catch (error) {
        console.log(error);
    }
}